module.exports = __webpack_public_path__ + "img/collar width.59c4a6b1.png";